import React, { ReactElement } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Link } from 'react-router-dom';
import { SimplePageTitle } from '@/components/layout/PageTitle';
import OrdersFilterableList, { OrdersViewMode } from './OrdersFilterableList';
import { Tabs } from '@ygtechnologies/rubus-ui';

type TabId = 'main';
interface TabSetup {
    id: TabId;
    name: ReactElement;
    url: string;
    render: (options: { projectId: number; mode: OrdersViewMode }) => ReactElement;
}

const tabs: TabSetup[] = [
    {
        id: 'main',
        url: 'orders',
        name: <Trans>All orders</Trans>,
        render: (options) => <OrdersFilterableList {...options} />,
    },
];
interface OrdersPageProps {
    projectId: string | number;
    mode: OrdersViewMode | null | undefined;
}

const OrdersPage: React.FC<OrdersPageProps> = ({ projectId, mode }) => {
    const tab: TabId = 'main';
    const activeTab = tabs.find((t) => t.id === tab) ?? tabs[0];

    return (
        <>
            <SimplePageTitle title={t`Orders`} />

            <Tabs.Container activeId={tab} variant="underline" sticky stickyClassName="stickyBleed">
                {tabs.map((t) => (
                    <Tabs.Tab key={t.id} id={t.id} as={Link} to={`/projects/${projectId}/${t.url}`} label={t.name} />
                ))}
                <Tabs.Content>{activeTab.render({ projectId: +projectId, mode: mode ?? 'all' })}</Tabs.Content>
            </Tabs.Container>
        </>
    );
};

export default OrdersPage;
